import { AgeChartItem, DonutChartDataItem, GenderTypeData } from 'src/app/models/core/chart-interfaces';
import { EMPTY_AGE_CHART_ITEMS, EMPTY_GENDER_CHART_ITEMS } from 'src/app/types/demographics.constants';
import { unwrapReportData } from './event-kpis.mapper';

/** Encabezados de la tabla de género; `type` es una clave de es.json. */
export const GENDER_TABLE_HEADERS = {
  type: 'reports-single-event.clients-tab.gender_title',
  total: 'Total',
  percentage: '%',
} as const;

export interface Demographics {
  readonly gender: DonutChartDataItem[];
  readonly age: AgeChartItem[];
}

export const EMPTY_DEMOGRAPHICS: Demographics = {
  gender: EMPTY_GENDER_CHART_ITEMS,
  age: EMPTY_AGE_CHART_ITEMS,
};

const nonEmpty = <T>(value: unknown, fallback: T[]): T[] =>
  Array.isArray(value) && value.length ? (value as T[]) : fallback;

/** Género y edad de `/demographics`; sin datos, los gráficos vacíos (no desaparecen). */
export function mapDemographics(raw: unknown): Demographics {
  const d = unwrapReportData(raw);
  return {
    gender: nonEmpty<DonutChartDataItem>(d['gender_chart_items'], EMPTY_GENDER_CHART_ITEMS),
    age: nonEmpty<AgeChartItem>(d['age_chart_items'], EMPTY_AGE_CHART_ITEMS),
  };
}

/** Filas de la tabla bajo la dona de género. */
export function toGenderTableRows(items: readonly DonutChartDataItem[]): GenderTypeData[] {
  return items.map((item) => ({
    type: item.type,
    amount: item.value.toString(),
    percentage: item.percentage,
    color: item.color,
  }));
}
